import { ProfessionalExperienceEntryType } from '../../../../Types/ProfessionalExperienceLineType';

export const schema: ProfessionalExperienceEntryType = {
	showMeOn: ['all'],
	timespan: '2025',
	length: '3 months', // adjust if needed
	noLeftColumn: true,
	title: 'Udemy - Data Science and Machine Learning Bootcamp with R',
	company: '2025',
	description: 'Comprehensive course covering deep learning fundamentals, real-world applications, and hands-on coding with state-of-the-art tools.',
	location: 'Online',
	technologies: ['Data Science', 'Machine Learning'],
	languages: ['R'],
	tools: ['R Studio', 'ggplot2', 'plotly', 'caret', 'dplyr', 'tidyverse', 'SQL'],
	skillsAcquired: ['R'],
	details: [
		{
			showMeOn: ['all'],
			entry: 'Developed proficiency in R programming for data science and machine learning applications.',
		},
		{
			showMeOn: ['all'],
			entry: 'Implemented machine learning models such as decision trees, random forests, KNN, and neural networks.',
		},
		{
			showMeOn: ['all'],
			entry: 'Created interactive data visualizations using ggplot2 and plotly, and applied data manipulation techniques with dplyr and tidyverse',
		},
		{
			showMeOn: ['all'],
			entry: 'Gained experience connecting R to databases, handling SQL queries, and web scraping for data extraction.',
		},
	],
};
